import { render, staticRenderFns } from "./MultipleFlightCreate.vue?vue&type=template&id=6700d162&"
import script from "./MultipleFlightCreate.vue?vue&type=script&lang=js&"
export * from "./MultipleFlightCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports